module.exports = __webpack_public_path__ + "static/media/Apple.127d2e41.svg";